import { Injectable, WritableSignal, inject } from '@angular/core';
import { LocationOfUser } from '@interfaces/modile-heart-beat/location-of-user';
import { MobileHeartBeatStore } from '@stores/mobile-heart-beat.store';

@Injectable({
  providedIn: 'root',
})
export class MobileHeartBeatService {
  public mobileHeartBeatStore = inject(MobileHeartBeatStore);
  locations = this.mobileHeartBeatStore.locations as WritableSignal<any[]>;

  updateLocation(newLocation: LocationOfUser) {
    const currentLocations = this.locations();
    const now = Date.now();

    const existingIndex = currentLocations.findIndex(
      (loc) => loc.userId === newLocation.userId,
    );

    if (existingIndex !== -1) {
      currentLocations[existingIndex] = {
        ...currentLocations[existingIndex],
        ...newLocation,
        lastUpdate: now,
      };
    } else {
      currentLocations.push({ ...newLocation, lastUpdate: now });
    }

    this.mobileHeartBeatStore.setLocations([...currentLocations]);
  }

  getLocations(): LocationOfUser[] {
    return this.locations();
  }
}
